import React from 'react';
import COLORS from '../../constants/colors';
import ProductAttributeSet from '../../components/ProductAttributeSet';
import ProductAttribute from '../../components/ProductAttribute';
import SectionTitle from '../../components/SectionTitle';
import wireframeIcon from './assets/wireframe.png';
import prototypeIcon from './assets/prototype.png';

const wireframeDescription = (
  <span>
    Wire-frames are like maps for how the website will function. They plan
    landing pages, buttons, and interactions on the site. Much like prototyping,
    wireframes are good for testing out ideas and seeing how they will function
    before having it fully designed.
  </span>
);

const prototypeDescription = (
  <span>
    Working prototypes make it easy to test out ideas before spending money on
    development. They're good for trying out a new product or testing a new
    business idea. Prototypes "click" and "move" like a normal site would but
    without being live on the web.
  </span>
);

function ProductPlanningTesting({ color }) {
  return (
    <div>
      <SectionTitle color={color}>
        PLANNING & TESTING&nbsp;
        <span style={{ color: COLORS.PURPLE }}> &#x25CF;</span>
      </SectionTitle>
      <ProductAttributeSet>
        <div className="row">
          <ProductAttribute
            icon={wireframeIcon}
            title="WIREFRAMING"
            description={wireframeDescription}
          />
          <ProductAttribute
            icon={prototypeIcon}
            title="WORKING PROTOTYPES"
            description={prototypeDescription}
          />
        </div>
      </ProductAttributeSet>
    </div>
  );
}

export default ProductPlanningTesting;



// WEBPACK FOOTER //
// ./src/components/ProductPlanningTesting/index.js